const pendingFileRenameFunctions = {
	NONE: "NONE",
	RENAME: "RENAME",
	POSIX_RENAME: "POSIX_RENAME",
};

export default pendingFileRenameFunctions;
